export default __webpack_public_path__ + "static/Event1-a31148b74e61980d1c3dcdff47599450.jpg";